import { twMerge } from "tailwind-merge";

export type DataListProps = {
    [key: string]: any;
};

type TableProps = {
    thead: {
        title: string;
        key: string;
        content?: (row: any, tbodyData: DataListProps) => void;
        thClassName?: string;
        tdClassName?: string;
    }[];
    tbody: DataListProps;
    className?: string;
};

export default function ConsoleHrozontalHeadTable({ thead, tbody, className }: TableProps) {
    const figureStyle = twMerge(`overflow-x-auto`, className);

    return (
        <figure className={figureStyle}>
            <table className="border-t border-black w-full">
                <tbody>
                    {thead.map(({ title, key, content, thClassName, tdClassName }, index) => {
                        const thStyle = twMerge(
                            "bg-[#F7F7F8] w-[130px] text-left p-[11px_8px] font-[400] whitespace-pre-wrap",
                            thClassName || "",
                        );
                        const tdStyle = twMerge("text-[#666666] px-[8px] text-[14px] whitespace-pre-wrap", tdClassName || "");
                        return (
                            <tr key={index} className="border-b border-[#dddddd]">
                                <th className={thStyle}>{title}</th>
                                <td className={tdStyle}>{content ? content(tbody[key], tbody) : tbody[key]}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </figure>
    );
}
